import { useMemo } from 'react';

import { TextCell } from './TextCell';

import type { TotalActionsRowItem } from '@/app/types/Dashboard';
import type { ColumnDefinition } from '@turnpike/portal-data-grid';

export const useTableTotalActionsColumns = () => {
	const columns = useMemo((): ColumnDefinition<TotalActionsRowItem>[] => {
		return [
			{
				key: 'total',
				title: 'Total',
				width: 110,
				draggable: false,
				render: (_value, row) => (
					<TextCell isBold={true}>{`${row.total.toFixed(0)}%`}</TextCell>
				),
			},
			{
				key: 'triggerName',
				title: 'Trigger Name',
				width: 160,
				draggable: false,
				render: (_value, row) => <TextCell isBold={false}>{row.triggerName}</TextCell>,
			},
			{
				key: 'organizationName',
				title: 'Organization Name',
				draggable: false,
				render: (_value, row) => (
					<TextCell accentColor={row.triggerColor} isBold={true}>
						{row.organizationName}
					</TextCell>
				),
			},
			{
				key: 'totalActions',
				title: 'Total Actions',
				width: 190,
				align: 'center',
				draggable: false,
				render: (_value, row) => (
					<TextCell isBold={true}>{`${row.totalActions.toFixed(0)}`}</TextCell>
				),
			},
			{
				key: 'acceptedActions',
				title: 'Accepted ',
				align: 'center',
				draggable: false,
				width: 180,
				render: (_value, row) => (
					<TextCell isBold={true}>{`${row.acceptedActions.toFixed(0)}%`}</TextCell>
				),
			},
			{
				key: 'declinedActions',
				title: 'Declined',
				align: 'center',
				draggable: false,
				width: 180,
				render: (_value, row) => (
					<TextCell isBold={true}>{`${row.declinedActions.toFixed(0)}%`}</TextCell>
				),
			},
			{
				key: 'noResponseActions',
				title: 'No Response',
				width: 200,
				draggable: false,
				align: 'center',
				render: (_value, row) => (
					<TextCell isBold={true}>{`${row.noResponseActions.toFixed(0)}%`}</TextCell>
				),
			},
			{
				key: 'acceptTime',
				title: 'Acceptance Time',
				draggable: false,
				align: 'center',
				width: 210,
				render: (_value, row) => (
					<TextCell isBold={true}>{`${row.acceptTime.toFixed(0)}s`}</TextCell>
				),
			},
		];
	}, []);

	return { columns };
};
